import { Box, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import SectionCollapsible from "../../common/SectionCollapsible";
import ReadOnlyOutcome, { Outcome } from "./ReadOnlyOutcome";
import { format } from "date-fns";

export const v3ActivationDateInMillis = 1694559600000;
const v3ActivationDate = new Date(v3ActivationDateInMillis);

function getOutcomeKey(version: "v2" | "v3", outcome: Outcome, index: number) {
  return [
    version,
    index,
    outcome.unit,
    outcome.value,
    outcome.startDate ?? "no-start-date",
    outcome.endDate ?? "no-end-date",
  ].join("+");
}

export function ReadOnlyOutcomesContainer({
  outcomes,
}: {
  outcomes: {
    v2: Array<Outcome>;
    v3: Array<Outcome>;
  };
}) {
  return (
    <Box data-testid="read-only-outcomes-container">
      <SectionCollapsible label="Outcomes">
        {!outcomes ||
        (!outcomes?.v2 && !outcomes?.v3) ||
        (outcomes?.v2.length === 0 && outcomes?.v3.length === 0) ? (
          <Box
            sx={{
              paddingBottom: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <WarningAmberIcon sx={{ marginRight: 1, color: "orange" }} />
            <Typography
              variant="subtitle1"
              color="error"
              sx={{
                fontWeight: "bold",
              }}
            >
              There are no outcomes configured for this project.
            </Typography>
            <Typography
              variant="subtitle1"
              color="error"
              sx={{
                width: "75%",
              }}
            >
              Please add them by editing the project.
            </Typography>
            <Typography
              variant="subtitle1"
              color="error"
              sx={{
                width: "75%",
              }}
            >
              Failure to do so will result in the misrepresentation of the
              Impact on the Client Dashboard.
            </Typography>
          </Box>
        ) : (
          <>
            <Box sx={{ paddingBottom: 2 }}>
              <Typography variant="h6" align="left">
                V2
              </Typography>
              <Typography variant="subtitle2" align="left">
                Applicable to clients onboarded (created at date) prior to{" "}
                {format(v3ActivationDate, "dd/MM/yyyy")}
              </Typography>
            </Box>
            {outcomes?.v2.map((outcome, index) => (
              <ReadOnlyOutcome
                key={getOutcomeKey("v2", outcome, index)}
                outcome={outcome}
                index={index}
              />
            ))}
            <Box sx={{ paddingBottom: 2, paddingTop: 4 }}>
              <Typography variant="h6" align="left">
                V3
              </Typography>
              <Typography variant="subtitle2" align="left">
                Applicable to clients onboarded (created at date) on or after{" "}
                {format(v3ActivationDate, "dd/MM/yyyy")}
              </Typography>
            </Box>
            {outcomes?.v3.map((outcome, index) => (
              <ReadOnlyOutcome
                key={getOutcomeKey("v3", outcome, index)}
                outcome={outcome}
                index={index}
              />
            ))}
          </>
        )}
      </SectionCollapsible>
    </Box>
  );
}

export default ReadOnlyOutcomesContainer;
